import { Product } from '@/api/backend/contract/Product';
import { ProductListItem } from '@/api/backend/contract/ProductList';
import { getInitialProductOffer } from '@/util/get-initial-product-offer';

import { sanitizeGTMString } from './sanitizeGTMString';

type GTMProductContract = Product | ProductListItem;

type MapProductGTMItemParams = {
  product: GTMProductContract;
  quantity?: number;
  selectOfferId?: string | number | null;
};

const getProductItemCategory2 = (product: GTMProductContract): string => {
  const names =
    'labels' in product && product.labels.length > 0
      ? product.labels.map((label) => label.name)
      : product.badges.map((badge) => (typeof badge === 'string' ? badge : badge.name));

  const value = names.map(sanitizeGTMString).filter(Boolean).join('::');

  return value || 'none';
};

export const mapProductGTMItem = (params: MapProductGTMItemParams, index: number) => {
  const { product, quantity, selectOfferId } = params;
  const selectedOffer =
    selectOfferId != null
      ? product.productOffers.find(
          (offer) =>
            String(offer.id) === String(selectOfferId) || offer.uuid === selectOfferId
        )
      : getInitialProductOffer(product.productOffers);

  return {
    item_id: product.sku || '',
    item_name: sanitizeGTMString(product.name),
    price: Number(selectedOffer?.price ?? product.price ?? product.oldPrice ?? 0),
    item_brand: '',
    item_category: sanitizeGTMString(product.categoryName),
    item_category2: getProductItemCategory2(product),
    variant: selectedOffer?.size || '',
    position: index + 1,
    quantity: quantity ?? 1
  };
};
